var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8653 47.8653C50.0436 45.687 53.5514 45.687 55.7297 47.8653L62.1513 41.4436C63.2829 40.3121 63.2829 38.5016 62.1513 37.3983L25.6017 0.848675C24.4701 -0.282892 22.6596 -0.282892 21.5564 0.848675L15.1347 7.27032C17.313 9.44859 17.313 12.9564 15.1347 15.1347C12.9564 17.313 9.44859 17.313 7.27032 15.1347L0.848675 21.5564C-0.282892 22.6879 -0.282892 24.4984 0.848675 25.6017L37.3983 62.1513C38.5299 63.2829 40.3404 63.2829 41.4436 62.1513L47.8653 55.7297C45.687 53.5514 45.687 50.0436 47.8653 47.8653Z",
    fill: "#583BE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5415 22.1777C36.2092 22.1777 39.9999 25.9685 39.9999 30.6362V39.0947H31.5415C26.8738 39.0947 23.083 35.3039 23.083 30.6362C23.083 25.9685 26.8738 22.1777 31.5415 22.1777Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4ff55ad1ce7a291268ee0e37016f31b0.svg";
export { ForwardRef as ReactComponent };